import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import React from "react";
import TextRequired from "../TextRequired";
import { FormNumberOfPaxProps, IFormNumberOfPax } from "./interface";

const FormNumberOfPax: React.FC<FormNumberOfPaxProps> = ({
  value,
  onSubmit,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IFormNumberOfPax>({ defaultValues: value });

  return (
    <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
      <FormControl isInvalid={errors?.numberOfPax ? true : false}>
        <FormLabel htmlFor="pax" size="sm" fontSize="sm">
          Number of People (Pax)<TextRequired>*</TextRequired>
        </FormLabel>
        <Flex gap={2}>
          <Box>
            <Input
              id="pax"
              type="number"
              {...register("numberOfPax", {
                required: true,
                min: 1,
                max: 50,
              })}
            />
          </Box>
          <Box>
            <Button type="submit">Submit</Button>
          </Box>
        </Flex>

        <FormErrorMessage>
          {errors?.numberOfPax?.type === "required" &&
            "Number of Pax is required!"}
          {errors?.numberOfPax?.type === "min" && "Minimum value is 1!"}
          {errors?.numberOfPax?.type === "max" && "Maximum value is 50!"}
        </FormErrorMessage>
      </FormControl>
    </form>
  );
};

export default FormNumberOfPax;
